import { render, staticRenderFns } from "./InfoButton.vue?vue&type=template&id=4247b321&scoped=true&"
import script from "./InfoButton.vue?vue&type=script&lang=ts&"
export * from "./InfoButton.vue?vue&type=script&lang=ts&"
import style0 from "./InfoButton.vue?vue&type=style&index=0&id=4247b321&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4247b321",
  null
  
)

export default component.exports